"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.subscribeModifyUserAliasEvent = exports.publishModifyUserAliasEvent = exports.UserAliasTypeEvent = void 0;
const factory_1 = require("./factory");
const events_1 = require("../events");
var UserAliasTypeEvent;
(function (UserAliasTypeEvent) {
    UserAliasTypeEvent["MODIFY_USER_ALIAS"] = "modifyUserAliasEvent";
})(UserAliasTypeEvent || (exports.UserAliasTypeEvent = UserAliasTypeEvent = {}));
exports.publishModifyUserAliasEvent = (0, factory_1.createPublishFunction)(UserAliasTypeEvent.MODIFY_USER_ALIAS, events_1.ModifyUserAliasEvent);
exports.subscribeModifyUserAliasEvent = (0, factory_1.createSubscribeFunction)(UserAliasTypeEvent.MODIFY_USER_ALIAS);
//# sourceMappingURL=userAlias.js.map